import { addLocaleData } from "react-intl";
import * as defaultLocale from "../../i18n/default";
export const I18N_ACTIONS = {
    SELECT_LOCALE: "select-locale",
    LOCALE_LOADED: "locale-loaded"
};
const loadedLocales = {};
async function tryImportLocale(locale, dispatch) {
    if (!loadedLocales[locale]) {
        loadedLocales[locale] = true;
        let data;
        let messages;
        switch (locale) {
            case "en":
                ({ data, messages } = defaultLocale);
                break;
            case "es":
                ({ data, messages } = await import(
                /* webpackChunkName: "locale-es" */
                "../../i18n/locale-es"));
                break;
            default:
                throw new Error("Unexpected state");
        }
        addLocaleData(data);
        dispatch({
            type: I18N_ACTIONS.LOCALE_LOADED,
            payload: {
                locale,
                messages
            }
        });
    }
}
export const selectLocale = (locale) => async (dispatch) => {
    await tryImportLocale(locale, dispatch);
    dispatch({
        type: I18N_ACTIONS.SELECT_LOCALE,
        payload: locale
    });
};
export const importLocale = (locale) => (dispatch) => tryImportLocale(locale, dispatch);



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/i18n/i18nActions.ts